function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2025Logo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 507.37 53.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "logo_IL_2024_full_-_primary"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.71,9.72c-8.67,0-15.7,7.03-15.7,15.7,0,5.41,2.74,10.18,6.91,13,.11.07.22.14.33.22.85.64,1.41,1.65,1.41,2.8v.65h3.97v-.65c0-.33-.03-.65-.07-.98h.01l-2.04-11.67-.84.13,1.39,8.01c-.41-.55-.9-1.05-1.46-1.46-.18-.13-.37-.26-.56-.37-3.19-2.2-5.09-5.8-5.09-9.67,0-6.47,5.26-11.74,11.73-11.74s11.73,5.27,11.73,11.74c0,3.79-1.83,7.34-4.91,9.54-.37.21-.72.45-1.05.72-.44.36-.83.76-1.16,1.2l1.39-7.95-.85-.1-1.92,10.98c-.03.12-.04.25-.06.38l-.05.26s0,.06-.01.08l-.02.25v1.31h3.96v-1.08c.11-.92.57-1.72,1.25-2.28.19-.15.39-.29.61-.4,4.1-2.84,6.78-7.56,6.78-12.91,0-8.67-7.03-15.7-15.69-15.7Z",
    style: {
      fill: "#0095ac"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.66,
    y: 49.45,
    width: 14.09,
    height: 3.97,
    style: {
      fill: "#0095ac"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.66 43.79 83.66 47.76 97.75 47.76 97.75 43.79 87.63 43.79 83.66 43.79",
    style: {
      fill: "#0095ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.57,25.34c.7,0,1.33.36,1.69.97.78,1.33,2.11,2.24,3.6,2.53l.85.1.6-3.44c-.14.04-.29.06-.45.06-.15,0-.29-.02-.42-.05-.53-.11-.98-.44-1.27-.93-.96-1.62-2.72-2.62-4.6-2.62s-3.64,1-4.6,2.62c-.24.41-.6.7-1.03.85-.2.08-.43.12-.66.12-.06,0-.12,0-.18-.01l.59,3.38.84-.13c1.38-.35,2.6-1.23,3.34-2.48.36-.61.99-.97,1.69-.97Z",
    style: {
      fill: "#0095ac"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 10.28,
    width: 4.76,
    height: 30.03,
    style: {
      fill: "#0095ac"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "32.52 31.64 15.49 10.28 11.8 10.28 11.8 40.3 16.65 40.3 16.65 19.12 33.68 40.3 37.32 40.3 37.32 10.28 32.52 10.28 32.52 31.64",
    style: {
      fill: "#0095ac"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.14 31.64 48.11 10.28 44.42 10.28 44.42 40.3 49.27 40.3 49.27 19.12 66.3 40.3 69.94 40.3 69.94 10.28 65.14 10.28 65.14 31.64",
    style: {
      fill: "#0095ac"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.27 10.28 121.66 34.69 112.09 10.28 106.69 10.28 119.17 40.43 124.19 40.43 136.63 10.28 131.27 10.28",
    style: {
      fill: "#0095ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.07,12.06c-.11-.07-.22-.14-.33-.22-.85-.64-1.41-1.67-1.41-2.82V0h-3.96v9.02c0,2.35,1.12,4.6,3,6.01.18.15.36.27.56.39,3.13,2.17,5.02,5.72,5.08,9.53-.28-.17-.51-.4-.69-.69-.96-1.64-2.72-2.65-4.6-2.65s-3.64,1.01-4.61,2.64c-.36.61-.99.98-1.69.98s-1.33-.36-1.69-.97c-.96-1.64-2.73-2.65-4.61-2.65s-3.65,1.01-4.6,2.64c-.23.39-.57.69-.98.84.02-3.8,1.85-7.34,4.91-9.55.37-.21.72-.45,1.05-.72,1.48-1.23,2.43-2.98,2.66-4.9l.03-.24V0h-3.97v9.44c-.11.92-.57,1.74-1.25,2.3-.2.16-.4.29-.62.4-4.1,2.85-6.78,7.6-6.78,13,0,8.73,7.03,15.8,15.7,15.8s15.7-7.07,15.7-15.8c0-5.45-2.74-10.25-6.91-13.09ZM217.29,36.95c-5.31,0-9.81-3.58-11.25-8.46,1.41-.33,2.65-1.23,3.41-2.5.36-.61.99-.98,1.69-.98s1.33.37,1.69.98c.96,1.62,2.73,2.64,4.61,2.64s3.64-1.02,4.6-2.64c.36-.61.99-.98,1.69-.98s1.33.37,1.69.98c.7,1.2,1.84,2.05,3.13,2.43-1.41,4.93-5.93,8.53-11.26,8.53Z",
    style: {
      fill: "#0095ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.55,10.28l-13.47,30.03h5.1l2.83-6.3h16.25l2.88,6.3h5.1l-13.47-30.03h-5.23ZM143.82,29.63l6.35-14.29,6.35,14.29h-12.69Z",
    style: {
      fill: "#0095ac"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.41 14.61 173.28 14.61 173.28 40.31 178.13 40.31 178.13 14.61 187.95 14.61 187.95 10.28 163.41 10.28 163.41 14.61",
    style: {
      fill: "#0095ac"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.85,
    y: 10.28,
    width: 4.76,
    height: 30.03,
    style: {
      fill: "#0095ac"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.79 31.64 241.76 10.28 238.07 10.28 238.07 40.3 242.92 40.3 242.92 19.12 259.95 40.3 263.59 40.3 263.59 10.28 258.79 10.28 258.79 31.64",
    style: {
      fill: "#0095ac"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.63 10.28 281.82 10.28 281.82 40.3 302.45 40.3 302.45 35.85 286.63 35.85 286.63 10.28",
    style: {
      fill: "#0095ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.15,30.97c-.33-6.25-6.02-7.91-12.02-8.74-3.95-.56-7.29-1.37-7.29-4.29s2.92-4.55,6.95-4.55c3.13.04,6.01,1.29,7.42,3.34l3.65-2.44c-2.53-4.03-6.86-5.06-11.2-5.06-5.4,0-11.62,2.4-11.58,8.62,0,6.43,5.66,7.94,11.62,8.75,4.2.56,7.68,1.67,7.68,4.93,0,3.78-3.99,4.98-7.59,4.98s-7.21-1.29-9.35-4.93l-3.6,2.4c2.74,5.06,7.16,6.82,12.91,6.82.56,0,1.11-.03,1.66-.07,2.2.07,6.34-1.49,7.46-2.29,4.1-2.9,3.15-7.34,3.28-7.48Z",
    style: {
      fill: "#0095ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.2,10.28l-13.47,30.03h5.11l2.83-6.3h16.26l2.87,6.3h5.1l-13.47-30.03h-5.23ZM314.46,29.63l6.35-14.29,6.35,14.29h-12.69Z",
    style: {
      fill: "#0095ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.47,24.82c2.83-1.16,4.16-3.43,4.16-5.96,0-5.96-4.51-8.58-10.21-8.58h-13.77v30.03h13.77c5.92,0,11.15-2.02,11.15-8.58,0-2.27-1.5-5.83-5.1-6.9ZM345.41,14.61h9.01c3.6,0,5.45,2.23,5.45,4.33,0,2.36-1.8,3.78-5.4,3.78h-9.05v-8.11ZM354.42,35.85h-9.01v-8.84h9.05c2.74,0,6.31,1.46,6.31,4.68s-3.69,4.16-6.35,4.16Z",
    style: {
      fill: "#0095ac"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M400.77,19.05c.04-6.26,5.96-8.96,11.41-8.96,5.92,0,12.34,2.41,12.34,9.43,0,7.52-5.66,8.96-11.88,8.96-2.45,0-6.42.63-6.42,3.85v2.54h18.39v5.2h-23.97v-7.78c0-6.8,6.17-8.83,12-8.83,2.24,0,6.34-.38,6.34-3.8,0-3.21-2.92-4.73-6.72-4.73-2.92,0-5.92,1.48-5.96,4.14h-5.54Z",
    style: {
      fill: "#0095ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.04,23.11c0-17.67,25.95-17.62,25.95,0v4.27c0,17.63-25.95,17.67-25.95,0v-4.27ZM433.57,27.38c0,10.74,14.88,10.74,14.88,0v-4.27c0-10.57-14.88-10.69-14.88,0v4.27Z",
    style: {
      fill: "#0095ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.57,19.05c.04-6.26,5.96-8.96,11.41-8.96,5.92,0,12.34,2.41,12.34,9.43,0,7.52-5.66,8.96-11.88,8.96-2.45,0-6.42.63-6.42,3.85v2.54h18.39v5.2h-23.97v-7.78c0-6.8,6.17-8.83,12-8.83,2.24,0,6.34-.38,6.34-3.8,0-3.21-2.92-4.73-6.72-4.73-2.92,0-5.92,1.48-5.96,4.14h-5.54Z",
    style: {
      fill: "#0095ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.73,15.76h-15.98v5.2h5.75c6.3,0,11.92,2.58,11.88,9.51,0,6.72-5.62,9.93-11.58,9.93-6.51,0-12.09-2.32-12.13-9.26h5.54c0,3.25,3.72,4.1,6.51,4.1s6.13-1.27,6.13-4.78c.04-3.34-3.3-4.31-6.34-4.31h-11.2v-15.64h21.43v5.24Z",
    style: {
      fill: "#0095ac"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2025Logo);
export default __webpack_public_path__ + "static/media/2025-logo.8b4324cb6c68ff4868de96e25bdcda1c.svg";
export { ForwardRef as ReactComponent };